export default "__VITE_ASSET__DkwS2GDd__"